import { Form, Select } from "antd"
import type Item from "antd/es/form/FormItem"
import type { NamePath } from "rc-field-form/lib/interface"
import React, { type ComponentProps, useEffect } from "react"

import InputNumber from "../../../../components/Input/InputNumber.tsx"
import { validateNumber } from "../../../../utils/validation/number.ts"
import {
  PROPOSAL_PERIODS,
  PROPOSAL_PERIODS_SELECT_OPTIONS
} from "../../constants/duration-types.ts"

interface PeriodSelectorProps<T> {
  durationName: NamePath<T>
  durationDependencies?: NamePath<T>[]
  //
  typeName: NamePath<T>
  formItemProps?: ComponentProps<typeof Item>
  //
  disabled?: boolean
}

export function DurationFormItem<T>({
  durationName,
  durationDependencies,
  typeName,
  formItemProps,
  disabled
}: PeriodSelectorProps<T>) {
  const form = Form.useFormInstance()

  useEffect(() => {
    const current = form.getFieldValue(typeName)
    if (!current) form.setFieldValue(typeName, PROPOSAL_PERIODS.DAYS)
  }, [form, typeName])

  return (
    <Form.Item
      name={durationName}
      dependencies={durationDependencies}
      rules={[
        { required: false, message: "Required" },
        { validator: validateNumber }
      ]}
      {...formItemProps}
    >
      <InputNumber
        disabled={disabled}
        min={1}
        placeholder="Enter duration"
        className="w-full"
        max={99999999}
        addonAfter={
          <Form.Item
            name={typeName}
            noStyle
            initialValue={PROPOSAL_PERIODS.DAYS}
            rules={[{ required: true, message: "Please select duration type" }]}
            getValueProps={(v) => ({ value: v || PROPOSAL_PERIODS.DAYS })}
            normalize={(v) => v || PROPOSAL_PERIODS.DAYS}
          >
            <Select
              disabled={disabled}
              className={"text-left"}
              style={{ width: 100 }}
              options={PROPOSAL_PERIODS_SELECT_OPTIONS}
            />
          </Form.Item>
        }
      />
    </Form.Item>
  )
}
